import ReactDOM from 'react-dom/client';
import App from './App';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import './style.css';
import { msalConfig } from './App.service';
import { MsalProvider } from '@azure/msal-react';


const msalInstance = new PublicClientApplication(msalConfig);
if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
}

msalInstance.addEventCallback((event) => {
    //@ts-ignore
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        //@ts-ignore
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
    <MsalProvider instance={msalInstance}>
        <App instance={msalInstance} />
    </MsalProvider>);

